import { useMutation } from '@tanstack/react-query';

import { createPortalSession } from '@/features/subscriptions/api/create-portal-session';
import { toast } from '@/shared/hooks/use-toast';

export function useCreatePortalSession() {
  return useMutation({
    mutationFn: createPortalSession,
    onSuccess: (data) => {
      // Redirect to Stripe Customer Portal
      window.location.href = data.portalUrl;
    },
    onError: (error) => {
      toast({
        title: 'Error',
        description:
          error instanceof Error
            ? error.message
            : 'Failed to open billing portal',
        variant: 'destructive',
      });
    },
  });
}
